import React, { useState } from "react";
import ReportDownloadSentContext from "./ReportDownloadSentContext";
import { randomStr } from "../../../utils/helper";

const ReportDownloadSentState = (props) => {
  const [apiData, setApiData] = useState({ data: [], isLoading: false });
  const [isBackgroundColor, setIsBackgroundColor] = useState(false);
  const [fromData, setFormData] = useState({
    title: "",
    aboutUs: "",
    order: 1,
    images: "",
    subTitle: "",
    isTitleShow: true,
    theme: 1,
    buttonText: "",
    buttonLink: "",
    otherData: [
      {
        id: randomStr(2),
        image: "",
        title: "",
        description: "",
      },
    ],
  });
  const [storeIndex, setStoreIndex] = useState("");
  const [isArrayImg, setIsArrayImg] = useState(false);
  const [isSingleImg, setIsSingleImg] = useState(false);
  const [isParent, setIsParent] = useState(false);
  const [formDataParent, setFormDataParent] = useState({
    name: "",
    wpNumber: null,
    email: "",
    contentMapId: "",
    style: {
      ".downloadbox-section": {
        padding: "50px 0",
        "background-color": "rgb(249 249 249 / 100)",
      },
      ".downloadbox-section.bg-image": {
        "background-image": "",
      },
      ".downloadbox-section.bg-image::before": {
        "background-color": "",
      },
      ".downloadbox-section .section-title-area": {
        "margin-bottom": "50px",
      },
      ".downloadbox-section .section-title-area .section-subtitle": {
        "font-size": "16px",
        "font-weight": "600",
        color: "rgb(255 73 124 / 100)",
        "background-color": "rgb(255 73 124 / 0.2)",
        padding: "5px 20px",
        p1: "5px",
        p2: "20px",
        "border-radius": "15px",
        display: "inline-block",
        "margin-bottom": "15px",
      },
      ".downloadbox-section .section-title-area .section-title": {
        "font-size": "44px",
        "font-weight": "600",
        color: "rgb(0 0 0 / 100)",
      },
      ".downloadbox-section .downloadbox": {
        "background-color": "rgba(255, 255, 255, 1)",
        padding: "40px 40px",
        p1: "40px",
        p2: "40px",
        "border-radius": "15px",
        border: "1px solid rgba(249, 249, 249, 1)",
        borderPx: "1px",
        borderThik: "solid",
        borderColor: "rgba(249, 249, 249, 1)",
        "border-top": "3px solid rgb(255 73 124 / 100)",
        borderTPx: "3px",
        borderTThik: "solid",
        borderTColor: "rgb(255 73 124 / 100)",
        "box-shadow": "5px 5px 15px rgba(0,0,0,0.09)",
        bs1: "5px",
        bs2: "5px",
        bs3: "15px",
        shedowColor: "rgb(0 0 0 / 0.09)",
      },
      ".downloadbox-section .downloadbox .form-control": {
        width: "100%",
        "margin-bottom": "10px",
        "background-color": "rgba(238, 238, 238, 1)",
        border: "2px solid rgba(238, 238, 238, 1)",
        borderPx: "2px",
        borderThik: "solid",
        borderColor: "rgba(238, 238, 238, 1)",
        "border-radius": "0",
        "font-size": "16px",
        appearance: "auto",
        outline: "none",
      },
      ".downloadbox-section .downloadbox .btn": {
        color: "rgba(255, 255, 255, 1)",
        "background-color": "rgb(255 73 124 / 100)",
      },
    },
  });
  const [collId, setCollId] = useState();
  const [backImageToggle, setBackImageToggle] = useState(false);
  const [boxSection, setBoxSection] = useState(false);
  const [id, setId] = useState("");
  const [childId, setChildId] = useState("");
  const [isEdit, setIsEdit] = useState(false);
  const [filter, setFilter] = useState("");
  const [navMenuId, setNavMenuId] = useState([]);
  const [theme, setTheme] = useState(false);
  const [settingFormData, setSettingFormData] = useState({});
  const [imgShow, setImgShow] = useState(false);
  const [sectionPageName, setSectionPageName] = useState("");

  return (
    <ReportDownloadSentContext.Provider
      value={{
        apiData,
        setApiData,
        fromData,
        setFormData,
        id,
        setId,
        isEdit,
        setIsEdit,
        filter,
        setFilter,
        settingFormData,
        setSettingFormData,
        formDataParent,
        setFormDataParent,
        navMenuId,
        setNavMenuId,
        fromData,
        setFormData,
        childId,
        setChildId,
        theme,
        setTheme,
        boxSection,
        setBoxSection,
        backImageToggle,
        setBackImageToggle,
        collId,
        setCollId,
        isParent,
        setIsParent,
        isBackgroundColor,
        setIsBackgroundColor,
        imgShow,
        setImgShow,
        sectionPageName,
        setSectionPageName,
        storeIndex,
        setStoreIndex,
        isArrayImg,
        setIsArrayImg,
        isSingleImg,
        setIsSingleImg,
      }}
    >
      {props.children}
    </ReportDownloadSentContext.Provider>
  );
};

export default ReportDownloadSentState;
